<template>
  <div>
    <v-flex style="max-width: 676px !important">
      <module-title class="title" title="Import/Export" />
      <v-flex>
        <v-layout :column="$vuetify.breakpoint.xs" class="cards-container">
          <v-flex class="import-export-card">
            <v-layout column align-center>
              <div class="import-export-image-margins">
                <img src="/assets/import.svg" alt="Import icon" />
              </div>
              <div class="import-export-name">Import</div>
              <div class="import-export-description import-export-screen-description-margins">
                Quickly import attendees and all of their data using a CSV template.
              </div>
            </v-layout>
          </v-flex>
          <v-flex class="import-export-card" @click="goTo(routes.theaterOrganizer.exportTheater)">
            <v-layout column align-center>
              <img src="/assets/export.svg" alt="export icon" class="import-export-image-margins" />
              <div class="import-export-name">Export</div>
              <div class="import-export-description import-export-screen-description-margins">
                Export a list of your attendees or a full set of your event's analytics data.
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </div>
</template>

<script>
import ModuleTitle from '@/components/shared/module-title.vue'

export default {
  name: 'theater-import-export-container',
  components: { ModuleTitle },
}
</script>

<style scoped></style>
